import * as React from 'react';
import { connect } from 'react-redux';
import '../../SuperUser/css/SuperUserPageView.css';
import { TooltipCont } from '../../../infrastructure/tooltips';
import { getScrollbarWidth } from '../../../lib/helpers';
import {
    ISeedProduct,
    ISeedCategory,
} from '../../../infrastructure/interfaces';
import SeedCloneForm from '../../Products/SeedCloneForm';
import PreviewSeedProductModal from '../../Modals/PreviewSeedProductModal/PreviewSeedProductModal';
import { FilterMenu } from '../../FilterMenu';

export interface ISeedsTableAgronomistProps {
  seedList: ISeedProduct[];
  seedCategories: ISeedCategory[];
}

export interface ISeedsTableAgronomistState {
    showCopyModal: boolean;
    showPreviewModal: boolean;
    copyingProduct: ISeedProduct | undefined;
    previewingProduct: ISeedProduct | null;
    seedsFilter: string;
    categoryFilter: string;
    publishedFilter: boolean | undefined;
}

const mapDispatchToProps = (dispatch: any) => {
    return {
    };
};

const mapStateToProps = (state: any) => {
  return {
      seedList: state.seedList,
      seedCategories: state.wizard.seedCategories,
  };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class SeedsTableAgronomist extends React.Component<
  ISeedsTableAgronomistProps,
  ISeedsTableAgronomistState
> {
  shouldUpdate = false;
  tableRow: HTMLElement;
  constructor(props: ISeedsTableAgronomistProps) {
    super(props);

    this.state = {
      showCopyModal: false,
      showPreviewModal: false,
      copyingProduct: undefined,
      previewingProduct: null,
      seedsFilter: '',
      categoryFilter: '',
      publishedFilter: undefined,
    };
  }

  componentWillReceiveProps(nextProps: any) {
    this.shouldUpdate = true;
  }

  onCopyProduct = (product: ISeedProduct) => {
    this.shouldUpdate = true;
    this.setState({
      copyingProduct: product,
      showCopyModal: true,
    });
  };

  onPreviewProduct = (product: ISeedProduct) => {
    this.shouldUpdate = true;
    this.setState({
      previewingProduct: product,
      showPreviewModal: true,
    });
  };

  filterProducts = (products: any[]) => {
    const seedsFilter = this.state.seedsFilter.toUpperCase();
    const seedsFilteredProducts = products.filter((p) =>
        seedsFilter ? (p.name.toUpperCase().indexOf(seedsFilter) > -1) : true
    );
    const filteredProducts = seedsFilteredProducts.filter((p) => {
          const includedInCategoryFilter = ((this.state.categoryFilter.length == 0) || (this.state.categoryFilter == (p.category && p.category.name)));
          const includedInPublishFilter = ((this.state.publishedFilter == undefined) || (this.state.publishedFilter == p.published));
          return includedInCategoryFilter && includedInPublishFilter;
        }
    );

    return filteredProducts;
  };

  onSearchFilterChange = (e: any) => {
    this.setState({
      seedsFilter: e.target.value,
    });
    // keyCode === 8 is a 'backspace' event
    e.keyCode === 8 && !e.target.value
      ? (this.shouldUpdate = true)
      : (this.shouldUpdate = false);
  };

  render() {
    const { seedList } = this.props;
    const filteredProducts = this.filterProducts(seedList);

    const { showCopyModal, showPreviewModal } = this.state;

    if (showCopyModal && (this.state.copyingProduct != undefined)) {
      return (
        <SeedCloneForm
            seed={this.state.copyingProduct}
            show={this.state.showCopyModal}
            onClose={() => this.setState({showCopyModal: false})}
        />

      );
    }

    if (showPreviewModal && this.state.previewingProduct) {
      return (
        <PreviewSeedProductModal
          show={this.state.showPreviewModal}
          product={this.state.previewingProduct}
          onClose={() => this.setState({ showPreviewModal: false })}
        />
      );
    }
    return (
      <div className="inner-su-container">
        <div className="manage-items-row">
          <div className="productTable-search">
            <input
              type="text"
              onKeyUp={this.onSearchFilterChange}
              placeholder="Search Products"
            />
          </div>

          <div className="in-row-text-container-products">Manage Seeds</div>

          <div className="in-row-button-container">
          </div>
        </div>
        <table className="table-scrollable documents-table">
          <thead style={{ paddingRight: getScrollbarWidth() }}>
            <tr>
              <th>Seed</th>
              <th>
                <FilterMenu
                    title="Category"
                    options={this.props.seedCategories.map((p) => {
                      return { title: p.name };
                    })}
                    onFilter={(filterApplied: string) => {
                      this.shouldUpdate = true;
                      this.setState({ categoryFilter: filterApplied });
                    }}
                />
              </th>
              <th>
                <FilterMenu
                    title="Published/Unpublished"
                    options={[{ title: 'Published' }, { title: 'Unpublished' }]}
                    onFilter={(filterApplied: string) => {
                      this.shouldUpdate = true;
                      var publishedFilter: boolean | undefined = undefined;
                      if (filterApplied == 'Published') {
                        publishedFilter = true;
                      } else if (filterApplied == 'Unpublished') {
                        publishedFilter = false
                      }
                      this.setState({ publishedFilter });
                    }}
                />
              </th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody className="document-table-body">
            {filteredProducts.map((p: ISeedProduct, index, array) => (
              <tr
                key={p.id + '_' + p.category.id}
                ref={(tr) => (this.tableRow = tr!)}
              >
                <td dangerouslySetInnerHTML={{ __html: p.name }} />
                <td>{(p.category && p.category.name) || 'Unknown'}</td>
                <td>{p.published ? 'Published' : 'Unpublished'}</td>
                <td>
                  <div className="button-wrapper">
                    <button
                      className="btn primary-blue"
                      onClick={() => this.onCopyProduct(p)}
                      title={TooltipCont.CLONE}
                      disabled={false}
                    >
                      Clone
                    </button>
                    <button
                      className="btn primary-blue"
                      onClick={() => this.onPreviewProduct(p)}
                      title={TooltipCont.PREVIEW}
                      disabled={false}
                    >
                      Preview
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Agronomist/components/SeedsTableAgronomist.tsx